import React from "react";
import ParticlesBackground from "../components/Effects/ParticlesBackground";
import AuthSidebar from "../components/Auth/AuthSidebar";
import "../styles/pages/Downloads.css";
import { useLanguage } from "../contexts/LanguageContext";

const Download: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="download-page">
      <ParticlesBackground />

      <div className="main-download-container">
        <div className="main-panel">
          <section className="hero-section">
            <h1>{t("downloads", "title")}</h1>

            <div className="download-container">
              <a
                href="https://github.com/orial021/aethelburg/releases/latest/download/borials_chronicle_setup_v1.0.exe"
                className="download-btn"
              >
                <span>
                  <i className="fas fa-download"></i>{" "}
                  {t("downloads", "windows")}
                </span>
              </a>
            </div>
            <div className="download-container">
              {/* Botón de Mac deshabilitado temporalmente con estilo visual */}
              <button
                className="download-btn"
                disabled
                style={{ opacity: 0.5, cursor: "not-allowed" }}
                title="Próximamente para macOS"
              >
                <span>
                  <i className="fab fa-apple"></i> {t("downloads", "mac")}{" "}
                  (Próximamente)
                </span>
              </button>
            </div>
          </section>
        </div>
        <AuthSidebar />
      </div>
    </div>
  );
};

export default Download;
